import React, { useEffect, useState } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { useVideo } from "../api/VideoProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import "../styles/devices/mob_Home.css";
import { useTranslation } from "react-i18next";
import { Recorder } from "../components/stream/Recorder";
import { useStreamProvider } from "../api/StreamProvider";
import { RecorderReferenceVideo2 } from "../components/donateSentences/RecorderReferenceVideo2";
import { ButtonGroup, Grid, FormControlLabel, Switch, Button, Paper } from "@material-ui/core";
import logoAndswerFree from "../assets/logos/icon-libre.png";
import logoCopy from "../assets/logos/icon-copiar.png";
import { pDataProvider, pDB_user_roles } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useHistory } from "react-router-dom";
import json_question from "../assets/csv/question.json";
import { useVideoSyncMonitor } from "../api/VideoSyncMonitor";
import { useCommProvider } from "../api/CommProvider";
import { saveVideo } from "../api/utils/webcam";
import CachedIcon from '@mui/icons-material/Cached';
import { useTimerProvider } from '../api/TimerProvider';


const TEST_TIMER_DEFINITION = {
  'max':  30,
  'min':  30,
  'step':  0,
  'timer': 30,
  'blocked': true
}


export function DonateResponse() {
  const { t } = useTranslation("global")

  const history = useHistory();

  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  /* Contexts */
  const { setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  const { token_id, currentUser, json_data_meaning, comm_getPublicURLVideoData } = useDataProvider();
  const { comm_sendVideo, comm_donateResponse, comm_getDonateResponse } = useCommProvider();


  const [src_video, set_src_video] = useState(null);
  const [video_id, set_video_id] = useState("")
  const [video_text , set_video_text ] = useState("");

  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [showFeedbackRecorder, setShowFeedbackRecorder] = useState(false);
  const [customTimerRecorder, setCustomTimerRecorder] = useState(TEST_TIMER_DEFINITION);

  const { 
    streamMediaBlobUrl, 
    setStreamMediaBlobUrl, 
    getStreamIsRecording, 
    streamInitRecording, 
    streamStartRecording, 
    streamPauseRecording, 
    streamStopRecording,
  } = useStreamProvider();

  const { 
    setTimerSpeed
  } = useTimerProvider();

  const {
    setIsLoopVideoRecorder,
    isLoadedReference,
    setIsLoadedReference
  } = useVideoSyncMonitor();

  /* Send video to server */
  async function send2ServerVideo(data) {

    data['sentence_id'] = video_id
    data['sentence_label'] = video_text

    const videoFile = await saveVideo(streamMediaBlobUrl);
    await comm_donateResponse(token_id, currentUser, videoFile, data);
    console.log("🚀 ~ send2ServerVideo ~ comm_donateResponse:", comm_donateResponse)
  }


  const getNewSample2 = async () => {
    // const keys = Object.keys(json_question);
    // const keys_priority_true = keys.filter(key => json_question[key].priority === true);
    // const keys_priority_false = keys.filter(key => json_question[key].priority === false);
    // let randomDefinitionKey = ''
    // if (Math.random()>0.8) {
    //   randomDefinitionKey = keys_priority_true[Math.floor(Math.random() * keys_priority_true.length)];  
    // } else {
    //   randomDefinitionKey = keys[Math.floor(Math.random() * keys.length)];
    // }

    const response = await comm_getDonateResponse(token_id, currentUser)
    const sentence_id = response['id']
    const sentence_text = response['text']

    console.log("🚀 ~ getNewSample2 ~ response:", response)
    
    set_src_video(comm_getPublicURLVideoData(pDataProvider.dir_vid_question, sentence_id));
    set_video_id(sentence_id)
    set_video_text(sentence_text)

    setIsLoopVideoRecorder(true)
    setIsLoadedReference(false)
  }

  useEffect(() => {
    getNewSample2()
    setTimerSpeed(1)
  }, []);


  const handleSend = () => {

    const data={
      'isValid': true
    }
    send2ServerVideo(data)

    setShowFeedbackRecorder(false)
    setStreamMediaBlobUrl(undefined)

    history.push({pathname: "/donateSentence"});
  };
    
  const handleDiscard = () => {
    console.log("🚀 ~ DonateSentence - handleDiscard ~ handleDiscard:", handleDiscard)

    const data={
      'isValid': false
    }
    send2ServerVideo(data)

    setShowFeedbackRecorder(false)
    setStreamMediaBlobUrl(undefined)

  };


  useEffect(() => {
    console.log("🚀 ~ DonateResponse ~ isLoadedReference:", isLoadedReference)
  }, [isLoadedReference]);

  const forceGetNextVideo = () => {
    getNewSample2()
  };

  return (
    <HomeWrapper>
      
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className='sig_SignModal_PaperInfo' style={{backgroundColor: '#00ff7214', border: "4px solid green", padding: '10px', width: '80%', borderRadius: '4px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <a href={logoAndswerFree} target="_blank" rel="noopener noreferrer">
            <img src={logoAndswerFree} alt="description" style={{width: '50px', height: '50px'}}/>
          </a>
          <div className="sig_SignModal_PaperLine">
            <span className="sig_VersusMachine_InfoTitle" style={{fontSize: '30px', color: 'purple'}}> RESPUESTA LIBRE: </span>
            <span className="sig_VersusMachine_InfoContent" style={{fontSize: '30px'}}> Mínimo tres signos.   </span>
          </div>
        </div> 
      </div>
      <Paper style={{ 
          backgroundColor: '#00ff7214', 
          border: "4px solid green", 
          position: 'relative', 
          display: 'flex', 
          flexDirection: 'row', 
          justifyContent: 'center', 
          transform: 'scale(1)', 
          margin: '-10px 1%', 
          padding: showFeedbackRecorder ? '0px 10px 50px 10px' : '0px 10px 10px 10px'
      }}>
        <div style={{ marginTop: '-5px', marginRight: '10px' }}>
          <RecorderReferenceVideo2 src_video={src_video} video_text={video_text} hideControls={false}/>
          {isLoadedReference==false && <Button style={{backgroundColor: '#f33333fc', borderRadius: '10px', marginTop: '-30px',  fontSize: '15px', color:'white', width: '100%', border: '3px solid red'}} onClick={forceGetNextVideo} > <CachedIcon style={{marginRight: '10px'}}/> RECARGAR VÍDEO  </Button>}
        </div>
        <div  style={{ marginLeft: '10px' }}>
          <Recorder action_send={handleSend} action_repeat={handleDiscard} customTimer={customTimerRecorder}/>
        </div>
      </Paper>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
    </HomeWrapper>
  );

}